import { verificationStatusList } from 'containers/CreativePreview/constants';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useUpdateCreativeMutation } from 'services/api/creativePreview';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { Form } from 'react-bootstrap';

function VerificationStatus({ id }) {
  const [modalState, setModalState] = useState({
    show: false,
    status: '',
    comment: '',
  });

  const closeModal = () =>
    setModalState({ show: false, status: '', comment: '' });

  const [_updateCreative, updateCreativeState] = useUpdateCreativeMutation();

  const updateCreative = (verificationStatus, comment) => {
    _updateCreative({ id, body: { verificationStatus, comment } });
  };

  useEffect(() => {
    if (updateCreativeState.isError) {
      toast.error(
        `Error Updating Creative : ${get(
          updateCreativeState,
          'error.data.error',
        )}`,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCreativeState.isError]);

  useEffect(() => {
    if (updateCreativeState.isSuccess) {
      closeModal();
    }
  }, [updateCreativeState.isSuccess]);

  return (
    <div className="update-container">
      <div className="label">Update Verification Status : </div>
      <div className="button-container">
        {verificationStatusList.map(status => (
          <Button
            variant={status.variant}
            onClick={() =>
              setModalState(prev => ({
                ...prev,
                status: status.title,
                show: true,
              }))
            }
            disabled={updateCreativeState.isLoading}
          >
            {status.title}
          </Button>
        ))}
      </div>
      <Modal show={modalState.show} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Update Verification Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Are you sure you want to update verification status to{' '}
            <b>{modalState.status}</b> ?
          </div>
          {modalState.status !== 'Right CTA' && (
            <Form.Group>
              <Form.Label style={{ fontWeight: 'bold' }}>Comment *</Form.Label>
              <Form.Control
                as="textarea"
                value={modalState.comment}
                onChange={e =>
                  setModalState(prev => ({ ...prev, comment: e.target.value }))
                }
              />
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              updateCreative(modalState.status, modalState.comment);
            }}
            disabled={
              updateCreativeState.isLoading ||
              (!modalState.comment.length && modalState.status !== 'Right CTA')
            }
          >
            Update
          </Button>
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default VerificationStatus;
